// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3k_bw","navigation":"Header_navigation__4Tv5L","actions":"Header_actions__3evfo"};